import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { TitleCSS } from '../styled';

export const Title = styled.div`
  ${TitleCSS}
  margin-bottom: 1.5rem;
`;

export const NoAlternativesWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  padding: 2.5rem 1.25rem;
  width: fit-content;
  @media (min-width: ${breakpoints.lg}) {
    padding: 2.5rem 3.5rem;
  }
`;

export const NoAlternativesTitle = styled.div`
  ${theme.typography.titleMedium}
  @media (min-width: ${breakpoints.lg}) {
    ${theme.typography.titleLarge}
  }
`;

export const NoAlternativesDescription = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
`;
